import { render, staticRenderFns } from "./CartEmpty.vue?vue&type=template&id=00a70a61"
import script from "./CartEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./CartEmpty.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports